<template>
  <div>
    <home></home>
    <div class="contentBlock">
        <!--资料-->
        <DingBU></DingBU>
        <!--输入资料-->
        <div style="position:relative">
            <InputData ref="submit"></InputData>
            <!-- <div style="position:absolute;bottom:99px;left:600px;">
                
                 <advance></advance>
            </div> -->
        </div>
    </div>
    <!--底部-->
    <earnings @BtnSubmitBtn="BtnSubmitBtn"></earnings>
  </div>
</template>

<script>
// 首页
import home from './components/home.vue'

// 导航栏资料
import DingBU from './components/Dzhiliao.vue'
// 输入资料
import InputData from './components/inputData.vue'
// 底部
import earnings from './components/earnings.vue'
export default {
  components:{
    home,
    DingBU,
    InputData,
    earnings
  },
  
  created(){
      
  },
  mounted(){
    window.scrollTo(0,750);
  },
  methods:{
    BtnSubmitBtn(){
        console.log('提交成功')
        this.$refs.submit.submitForm("ruleForm")
    }
  }
}
</script>

<style lang="scss" scoped>
    .contentBlock{
       width:1200px;
       margin: 0 auto;
       margin-top:30px;
    }
</style>